<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" fill="white" viewBox="0 0 512 512">
<path d="M96 64l320 192-320 192z"></path>
</svg>
</template>
